const getAuthority = (tenantId) => {
  return `https://login.microsoftonline.com/${tenantId}`;
};

const getRedirectUri = () => {
  return (
    process.env.REACT_APP_AZURE_REDIRECT_URI ||
    (typeof window !== "undefined" ? window.location.origin : "")
  );
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
    authority: getAuthority(process.env.REACT_APP_AZURE_TENANT_ID),
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      logLevel: process.env.NODE_ENV === "development" ? 3 : 0,
    },
  },
};

export const loginRequest = {
  scopes: [`${process.env.REACT_APP_AZURE_SCOPES}`, "User.Read"],
};

const apiScopes = process.env.REACT_APP_API_SCOPES
  ? process.env.REACT_APP_API_SCOPES.split(",").map((s) => s.trim())
  : loginRequest.scopes;

export const apiRequest = { scopes: apiScopes };

export const isAuthConfigured = () =>
  Boolean(process.env.REACT_APP_AZURE_CLIENT_ID);
